.filter-bar-button-tooltip {
  white-space: nowrap;
}
